{
    "TelephonenosLabel": "Telefonnummer(n):",
    "AcdagentsLabel": "ACD-Agent(en):",
    "LocationLabel": "Standort nach\/von:",
    "LocationOptionAny": "[Jeder Anruf zu\/von diesen Standorten]",
    "LocationOptionFrom": "Nur Anrufe von diesen Standorten",
    "LocationOptionTo": "Nur Anrufe an diese Standorte",
    "LocationalFiltering_SectionHeader": "Standortfilterung",
    "LocationalFiltering_AnyPlaceholder": "[Irgendein]",
    "LocationalFiltering_DevicesLabel": "Geräte):",
    "NAME": "LocationalFiltering",
    "TelephonenosLabelDNIS": "Telefonnummer(n) \/ DNIS-Nummer(n):",
    "TelephonenoDescriptionsLabel": "Telefon Nr. Beschreibung(en):",
    "AcdagentsLabel_MST": "Agent(en):"
}